<template>
	<div class="tender-top">
		<div class="tender-top__tabs">
			<div class="tab">
				<button class="tab__item"
					v-for="item in listTab"
					:key="item"
					:class="{'active' : item.tab === currentTab}"
					@click="changeTab(item.tab)"
					>
				{{ item.name }}
				</button>
			</div>
		</div>
		<div v-if="tender.id" class="tender-top__btns">
			<button class="btn btn--color" @click="handleCopyTender">Скопировать {{ currentTab === 'TN' ? 'тендер' : 'запрос'  }}</button>
		</div>
	</div>
	<transition name="modal">
		<CopyTenderPopup
			v-if="showCopyTenderPopup"
			:tender="tender"
			@close="showCopyTenderPopup = false"
		/>
	</transition>
</template>
<script>
import CopyTenderPopup from "@/components/sections/Tenders/TenderInner/CopyTenderPopup.vue";


export default {
	name: "TenderTab",
	emits: ["update:modelValue"],
	components: {
		CopyTenderPopup
	},
	props: {
		modelValue: {
			type: String,
		}
	},
	data() {
		return {
			currentTab: 'TN',
			listTab: [
				{
					name: 'Тендер',
					tab: 'TN'

				},
				{
					name: 'Коммерческое предложение',
					tab: 'CO'

				},
			],
			showCopyTenderPopup: false,
			tender: {
				id: (new URL(document.location)).searchParams.get("ID"),
				type: {
					code: this.currentTab
				}
			}
		}
	},
	methods: {
		changeTab(tab) {
			this.currentTab = tab
			this.$emit('update:modelValue', this.currentTab)
		},
		toggleCo() {
			this.currentTab = 'CO'
			this.$emit('update:modelValue', this.currentTab)
		},
		handleCopyTender() {
            this.showCopyTenderPopup = true
        },
	}
}
</script>
